export default __webpack_public_path__ + "static/media/img-service-transport.84391dd0.png";